<template>
  <v-container fluid>
    <h2 class="my-4 custom-text-9" style="margin-top: 100px;">HUBUNGI KAMI</h2>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <v-form @submit.prevent="sendEmail">
          <v-text-field v-model="form.name" label="Nama" outlined color="#900C27" required></v-text-field>
          <v-text-field v-model="form.email" label="Email" outlined color="#900C27" required type="email"></v-text-field>
          <v-textarea v-model="form.message" label="Pesan" outlined color="#900C27" required></v-textarea>
          <v-btn type="submit" large block color="#F6C667" class="white--text">Send</v-btn>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import auditrail  from "../../../api/AuditrailApi";

export default {
  async mounted(){
    await auditrail.create({
      action: this.$route.path
    });
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        message: ''
      },
      // ... other data properties ...
    };
  },
  methods: {
    async sendEmail() {
      try {
        // Here you would send the form data to your server-side script.
        // For demonstration, I'm using a placeholder URL.
        const response = await fetch('/api/send-email', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.form)
        });

        if (response.ok) {
          // Handle success
          alert('Email sent successfully!');
        } else {
          // Handle error
          alert('Failed to send email.');
        }
      } catch (error) {
        console.error('There was an error sending the email:', error);
      }
    }
  }
};
</script>

<style scoped>
.custom-text {
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 900;
  font-size: 22px;
  color: black;
  text-align: justify;
}
</style>
